import TagManager from 'react-gtm-module';

import { IS_PRODUCTION } from 'utils/envs';

export enum AnalyticsEvent {
  PAGE_CHANGE = 'page_change',
  PAGE_LOADED = 'page_loaded',
  MAIN_SLIDER_CLICK = 'main_slider_click',
  MAIN_NEWS_ITEM_CLICK = 'main_news_item_click',
  MAIN_NEWS_SHOW_ALL_CLICK = 'main_news_show_all_click',
  MAIN_CONTENT_ITEM_CLICK = 'main_content_item_click',
  MAIN_EVENTS_PREVIEW_CLICK = 'main_events_preview_click',
  MAIN_EVENTS_SHOW_ALL_CLICK = 'main_events_show_all_click',
  EVENTS_FILTER_SELECT = 'events_filter_select',
  EVENTS_PREVIEW_CLICK = 'events_preview_click',
  EVENTS_SAMECITY_CLICK = 'events_samecity_click',
  CONTENT_SLIDER_ITEM_CLICK = 'content_slider_item_click',
  CONTENT_ITEM_CLICK = 'content_item_click',
  CONTENT_PODCAST_SHARE_CLICK = 'content_podcast_share_click',
  CONTENT_PODCAST_TIME_ON_PAGE = 'content_podcast_time_on_page',
  CONTENT_PODCAST_DURATION_LISTENED_AUDIO = 'content_podcast_duration_listened_audio',
  CONTENT_VIEW = 'content_view',
  CONTENT_FORMAT_CARD_CLICK = 'content_format_card_click',
  NEWS_ITEM_CLICK = 'news_item_click',
  LOGIN = 'login',
  PROFILE_CHANGE_AVATAR_CLICK = 'profile_change_avatar_click',
  PROFILE_CHANGE_AVATAR_COMPLETE = 'profile_change_avatar_complete',
  PROFILE_SAVE_PERSONAL_DATA = 'profile_save_personal_data',
  PROFILE_SAVE_TOPICS = 'profile_save_topics',
  EVENT_REGISTRATION_BTN_CLICK = 'event_registration_btn_click',
  REGISTER_EVENT = 'register_event',
  EVENT_OTHER_EVENTS_BTN_CLICK = 'event_other_events_btn_click',
  EVENT_DESCRIPTION_MORE_BTN_CLICK = 'event_description_more_btn_click',
  EVENT_TELEGRAM_BOT_CONNECT = 'event_telegram_bot_connect',
  QUIZ_REGISTRATION_CLICK = 'quiz_registration_click',
  QUIZ_REGISTRATION_COMPLETE = 'quiz_registration_complete',
  QUIZ_RULES_CLICK = 'quiz_rules_click',
  LECTURERS_LEAGUE_REGISTRATION_CLICK = 'lecturers_league_registration_click',
  LECTURERS_LEAGUE_REGISTRATION_COMPLETE = 'lecturers_league_registration_complete',
  SPECIAL_PROJECT_ITEM_CLICK = 'special_project_item_click',
  SEARCH_ACTION = 'search_action',
  COLLECTION_SLIDER_ARROW_CLICK = 'collection_slider_arrow_click',
  COLLECTION_SLIDER_DETAILS_CLICK = 'collection_slider_details_click',
  ALL_COLLECTIONS_SLIDER_ARROW_CLICK = 'all_collections_slider_arrow_click',
  ALL_COLLECTIONS_SLIDER_DETAILS_CLICK = 'all_collections_slider_details_click',
  ALL_COLLECTIONS_CONTENT_ITEM_CLICK = 'all_collections_content_item_click',
  ALL_COLLECTIONS_TIME_ON_PAGE = 'all_collections_time_on_page',
  LIKE_CLICK = 'like_click',
  FAVORITE_CLICK = 'favorite_click',
  INVITE_SPEAKERS_PAGE_LOADED = 'attractspeaker.page_loaded',
  INVITE_SPEAKERS_MAIN_REGISTRATION_CLICK = 'attractspeaker.main_registration_click',
  INVITE_SPEAKERS_SECONDARY_REGISTRATION_CLICK = 'attractspeaker.secondary_registration_click',
  AUDIO_PLAYER_PLAY_CLICK = 'audio_player_play_click',
  CONTENT_NPS = 'content_nps',
  EXIT_ATTEMPT = 'exit_attempt',
  TOP_FILMS_COLLECTION_SHOW_MORE_BTN_CLICK = 'top_films_collection_show_more_btn_click',
  TOP_FILMS_COLLECTION_TIME_ON_PAGE = 'top_films_collection_time_on_page',
  LIBRARY_MACRO_TAG_NEW_COLLECTIONS_ITEM_CLICK = 'library_macro_tag_new_collections_item_click',
  MICRO_TAG_FILTER_OPTION_CLICK = 'micro_tag_filter_option_click',
  MICRO_TAG_FILTER_OPTION_CLICK_LIBRARY = 'micro_tag_filter_option_click_library',
  MACRO_TAG_TIME_ON_PAGE = 'macro_tag_time_on_page',
  DAILY_QUESTION_REGISTRATION_SHOW = 'daily_question_registration_show',
  DAILY_QUESTION_SEND_ANSWER = 'daily_question_send_answer',
  DAILY_QUESTION_ANSWER_RESULT = 'daily_question_answer_result',
  DAILY_QUESTION_CLOSE_RESULT = 'daily_question_close_result',
  PROFILE_TAB_SWITCH = 'profile_tab_switch',
  SHARE_WITH_LINK = 'share_with_link',
  SHARE_WITH_VK = 'share_with_vk',
  TEST_VIDEO_PLAYER_OPEN = 'test_video_player_open',
  TEST_VIDEO_PLAYER_CLOSE = 'test_video_player_close',
  TEST_VIDEO_PLAYER_TIMING_BEFORE_CLOSE = 'test_video_player_timing_before_close',
  TEST_VIDEO_PLAYER_PAUSE_TIMING = 'test_video_player_pause_timing',
  TEST_VIDEO_PLAYER_SEEK_TIMING = 'test_video_player_seek_timing',
  CINEMA_TIME_ON_PAGE = 'cinema_time_on_page',
  MACRO_TAG_FILTER_OPTION_CLICK = 'macro_tag_filter_option_click',
  MACRO_TAG_FILTER_OPTION_CLICK_LIBRARY = 'macro_tag_filter_option_click_library',
  TEST_VIDEO_PLAYER_PERCENT_WATCHING = 'test_video_player_percent_watching',
  SIMILAR_CONTENT_ITEM_CLICK = 'similar_content_item_click',
  SPEAKER_NPS = 'speaker_nps',
  PAGE_LEAVE = 'page_leave',
  ARTICLE_TIME_ON_PAGE = 'article_time_on_page',
  RECENT_ARTICLE_CLICK = 'recent_article_click',
  ARTICLE_PERCENT_READING = 'article_percent_reading',
  BREADCRUMBS_LINK_CLICK = 'breadcrumbs_link_click',
  DAILY_QUESTION_CINEMA_LINK_CLICK = 'daily_cinema_link_click',
  DAILY_QUESTION_CONTENT_LINK_CLICK = 'daily_question_content_link_click',
  REGISTER_BTN_CLICK_FROM_RESTRICTED_CONTENT = 'register_btn_click_from_restricted_content',
  SUCCESSFUL_REGISTRATION_FROM_RESTRICTED_CONTENT = 'successful_registration_from_restricted_content',
  EVENT_CARD_CLICK = 'event_card_click',
  CLICK_ON_BOX_FILMS = 'click_on_box_films',
  CLICK_ON_BOX_EVENTS = 'click_on_box_events',
  CLICK_ON_BOX_LECTURES = 'click_on_box_lectures',
  CLICK_ON_BOX_ARTICLES = 'click_on_box_articles',
  CLICK_ON_BOX_COURSES = 'click_on_box_courses',
  CLICK_ON_BOX_BECOME_SPEAKER = 'click_on_box_become_speaker',
  CLICK_SPEAKERS_MAIN_PAGE = 'speakers_click_main_page_speakersblock',
  CLICK_INVITE_LECTOR = 'invite_speakers_main_page_speakersblock',
  ABOUT_COURSE_BTN_CLICK = 'about_course',
  GET_COURSE_BTN_CLICK = 'get_course',
  REDIRECT_TO_ACADEMY = 'akademiya.registration',
  LK_ACADEMY_SECTION_CLICK = 'click_lk_akademiya',
  CLICK_MATERIALS_LECTOR = 'materials_with_speaker_click',
  CLICK_EVENTS_RECORD = 'broadcasts_with_speaker_click',
  CLICK_VIDEO_INTERESTING = 'you_mb_interested_click',
  CLICK_PODCAST_LISTENING = 'now_listening_click',
  POLL_SENDED = 'poll_sended',
}

/**
 * Отправка ивентов в аналитику через GTM-апи
 * @param event - произвольное название ивента
 * @param params - произвольный список дополнительных параметров
 */
export const trackAnalyticsData = (event: string, params: any = {}) => {
  if (IS_PRODUCTION) {
    TagManager.dataLayer({
      dataLayer: {
        event: 'trackAnalytics',
        payload: {
          event,
          params,
        },
      },
    });
  } else {
    console.log(`Event - ${event}, Params - ${JSON.stringify(params)}`);
  }
};
